import { render, staticRenderFns } from "./importantGeneDetails.vue?vue&type=template&id=7b4f9220&scoped=true"
import script from "./importantGeneDetails.vue?vue&type=script&lang=js"
export * from "./importantGeneDetails.vue?vue&type=script&lang=js"
import style0 from "./importantGeneDetails.vue?vue&type=style&index=0&id=7b4f9220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f9220",
  null
  
)

export default component.exports